import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import type { IconName } from '@core/user-interface-legacy';
import { IconComponent } from '@core/user-interface-legacy';
import type { DataSourceLayout } from '@core/views-types';

export const LAYOUT_ICON_MAP: Record<DataSourceLayout['type'], IconName> = {
  table: 'view-week',
  list: 'view-stream',
  board: 'pipeline',
};

@Component({
  selector: 'rt-views-layout-button',
  imports: [IconComponent],
  templateUrl: './layout-button.component.html',
  styleUrls: ['./layout-button.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LayoutButtonComponent {
  public icon = input.required<IconName>();
  public text = input.required<string>();
  public isActive = input.required<boolean>();
}
